<template>
    <v-combobox
        v-model="valueInner"
        :items="items"
        hide-details
        class="ScenarioComboBox"
        :class="{empty: isEmpty}"
        :multiple="multiple"
        :readonly="readonly"
        chips
        @focusout="focusout"
        @focusin="focusin"
    ></v-combobox>
</template>

<script>
export default {
    name: 'ScenarioComboBox',
    props: {
        value: String,
        items: Array,
        multiple: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            valueInner: '',
            shouldSave: false
        }
    },
    computed: {
        isEmpty () {
            if (this.multiple) {
                return this.valueInner.length === 0
            } else {
                return !!this.valueInner
            }
        }
    },
    methods: {
        // need to do both focus in and out because of this shitty v-combobox does not get latest value on focus out
        focusin () {
            this.shouldSave = false
        },
        focusout () {
            this.shouldSave = true
            if (JSON.stringify(this.value) !== JSON.stringify(this.getValueOut())) {
                this.$emit('input', this.getValueOut())
                this.$emit('save')
            }
        },
        handleValueChange () {
            if (this.multiple) {
                this.valueInner = this.value ? this.value.split(';') : ''
            } else {
                this.valueInner = this.value ? this.value.split(';')[0] : []
            }
        },
        getValueOut () {
            let valueOut = null
            if (this.multiple) {
                valueOut = []
                for (let item of this.valueInner) {
                    valueOut.push(typeof item == 'string' ? item : item.value)
                }
                valueOut = valueOut.join(';')
            } else {
                valueOut = this.valueInner
            }
            return valueOut
        }
    },
    watch: {
        value: {
            immediate: true,
            handler: 'handleValueChange'
        },
        multiple () {
            this.handleValueChange()
            this.focusout()
        },
        valueInner () {
            if (this.shouldSave) {
                this.shouldSave = false
                if (JSON.stringify(this.value) !== JSON.stringify(this.getValueOut())) {
                    this.$emit('input', this.getValueOut())
                    this.$emit('save')
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">
.ScenarioComboBox {
    min-height: 32px;
    background: #FFFFFF;
    border: 1px solid #D9D9D9;
    border-radius: 5px;
    outline: none;
    font-size: 14px;
    padding: 6px;
    margin: 0;
    display: flex;
    align-items: center;

    &.empty {
        //height: 40px;
    }

    &.v-input--is-focused {
        border-color: #D9DBDE;
    }

    ::v-deep * {
        &:before, &:after {
            border: none !important;
        }

        .v-select__selections {
            white-space: nowrap;
            min-height: 0;

            input {
                padding: 4px 0;
            }
        }

        .v-chip__content {
            height: 20px;
            padding: 0 6px;
            z-index: 0;
        }
    }
}

::v-deep {
    .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

}
</style>
